import { CustomDisclosure } from '@/components/ui/disclosure';
import { useRouter } from 'next/router';
import Sorting from '../sorting';
import classNames from 'classnames';
import { useAtom } from 'jotai';
import { drawerAtom } from '@/store/drawer-atom';
import Button from '@/components/ui/button';
import dynamic from 'next/dynamic';
import { useDrawer } from '../../ui/drawer/useDrawer';
import { searchDrawerAtom } from '@/store/searchDrawerAtom';
import SearchWithSuggestion from '../../ui/search/search-with-suggestion-typesense';
import { ClearFiltersButton } from './clear-button';
// import PriceFilter from '@/components/search-view/price-filter';

const CustomRefinementList = dynamic(
  () =>
    import('../custom-refinement-list').then(
      (module) => module.CustomRefinementList,
    ),
  { ssr: false },
);

export const FieldWrapper = ({ children, title, className }: any) => (
  <div
    className={classNames(
      'border-b border-accent py-7 last:border-0',
      className,
    )}
  >
    <CustomDisclosure title={title}>{children}</CustomDisclosure>
  </div>
);

export const SidebarFilter: React.FC<{
  type?: string;
  showManufacturers?: boolean;
  className?: string;
  /** When set, restricts the categories.name facet to these names only. */
  childCategoryNames?: string[];
}> = ({ type, className, childCategoryNames }) => {
  const router = useRouter();
const [_, closeSidebar] = useAtom(drawerAtom);
  const { closeDrawer } = useDrawer({ atom: searchDrawerAtom });

  const closeDrawers = () => {
    closeSidebar({ display: false, view: '' });
    closeDrawer();
  };

  return (
    <div
      className={classNames(
        'flex h-full w-full flex-col bg-white lg:h-auto',
        className,
      )}
    >
      <div className="flex-1 px-5">
        <FieldWrapper title="text-search" className="pb-4">
          <SearchWithSuggestion
            label={"pesquisa de mantimentos no cabeçalho"}
            variant="minimal"
          />
          <div className="flex justify-end pt-5">
            <ClearFiltersButton />
          </div>
        </FieldWrapper>

        {router.route !== '/[searchType]/search' && (
          <FieldWrapper title="text-sort">
            <Sorting />
          </FieldWrapper>
        )}

        <CustomRefinementList childCategoryNames={childCategoryNames} />

        {/* TODO: add price filter and review */}
        {/* <FieldWrapper title="text-sort-by-price">
          <PriceFilter />
        </FieldWrapper> */}
      </div>
      <div className="sticky bottom-4 z-10 border-gray-200 bg-white p-5 lg:hidden">
        <Button className="w-full" onClick={closeDrawers}>
          {"Mostrar Produtos"}
        </Button>
      </div>
    </div>
  );
};
